// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__2pdQA","btnRed":"styles_btnRed__3P6vx","container":"styles_container__1iZdR","group":"styles_group__2oplc","text":"styles_text__89rM5"};